<template>
  <div class="group">
    <div class="group-item" v-for="group in groupList" :key="group.id">
      <div class="title">{{ group.name }}</div>

      <div class="group-app-item">
        <GroupAppIcon v-for="item in group.children" :key="item.id" :item="item" :mobile="true"/>
      </div>

    </div>
  </div>
</template>


<script>
import GroupAppIcon from "@/views/GroupAppIcon.vue";

export default {
  name: "MobileGroupDesktop",
  components: {GroupAppIcon},
  computed: {
    groupList() {
      let icons = []
      this.$store.state.core.applications.forEach(item => {
        icons.push(item)
      })
      return icons;
    }
  },
}
</script>

<style lang="less" scoped>
@import 'node_modules/joysun-frame/packages/css/global.less';

.group {
  color: #FFFFFF;
  display: flex;
  position: absolute;
  top: @taskHeight;
  bottom: 0;
  overflow: auto;
  flex-wrap: wrap;
  width: 100%;

  .group-item {
    width: 100%;
    margin: 10px 10px 0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .title {
      width: 100%;
      margin: 2px;
      border-bottom: 1px solid white;
      text-align: left;
      font-size: 14px;
      font-weight: bold;
      line-height: 26px;
    }
  }

  .group-app-item {
    display: flex;
    flex-wrap: wrap;
  }

}
</style>